import { render, staticRenderFns } from "./ExportSettingsRunDetails.vue?vue&type=template&id=570d8c80&scoped=true"
import script from "./ExportSettingsRunDetails.vue?vue&type=script&lang=js"
export * from "./ExportSettingsRunDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d8c80",
  null
  
)

export default component.exports